(function () {
  'use strict';
  var cleanups = new WeakMap();
  function nodes(root) {
    var list = Array.from(root.querySelectorAll('[data-product-section]'));
    if (root.matches && root.matches('[data-product-section]')) list.unshift(root);
    return list;
  }
  function init(section) {
    var context = section.querySelector('[data-journey-context]');
    if (!context) return;
    if (cleanups.has(section)) cleanups.get(section)();
    var controller = new AbortController();
    var on = function (target, name, fn) { target.addEventListener(name, fn, { signal: controller.signal }); };
    var select = section.querySelector('[data-variant-select]');
    var quantity = section.querySelector('[data-order-quantity]');
    var price = context.querySelector('[data-journey-price]');
    var readiness = context.querySelector('[data-journey-readiness]');
    var panel = section.querySelector('[data-artwork-panel]');
    var format = new Intl.NumberFormat(section.dataset.locale || document.documentElement.lang || 'en', { style: 'currency', currency: section.dataset.currency || 'USD' });
    function amount(cents) { return format.format(cents / 100); }
    function sync() {
      if (!price) return;
      var choice = select ? select.selectedOptions[0] : section.querySelector('input[name="id"]');
      var q = quantity ? Number(quantity.value) : 1;
      var cents = choice && Number(choice.dataset.cents);
      var valid = choice && choice.dataset.available === 'true' && Number.isSafeInteger(q) && q > 0 && Number.isSafeInteger(cents) && cents >= 0 && Number.isSafeInteger(cents * q) && (!quantity || quantity.validity.valid);
      price.hidden = !valid;
      if (!valid) return;
      var tier = q >= 10 ? 10 : q >= 5 ? 5 : q >= 3 ? 3 : q >= 2 ? 2 : 0;
      var rate = section.dataset.bulkEnabled === 'true' && tier ? Number(section.getAttribute('data-bulk-discount-' + tier)) : 0;
      if (!Number.isFinite(rate) || rate <= 0 || rate > 100) rate = 0;
      var base = cents * q;
      var savings = Math.round(base * rate / 100);
      price.querySelector('[data-journey-size]').textContent = select ? choice.textContent.trim() : section.dataset.productName;
      price.querySelector('[data-journey-quantity]').textContent = String(q);
      price.querySelector('[data-journey-base]').textContent = amount(base);
      price.querySelector('[data-journey-savings-row]').hidden = rate === 0;
      price.querySelector('[data-journey-discount-note]').hidden = rate === 0;
      price.querySelector('[data-journey-percent]').textContent = '(' + rate + '%)';
      price.querySelector('[data-journey-savings]').textContent = amount(savings);
      price.querySelector('[data-journey-net]').textContent = amount(base - savings);
    }
    function describeTools() {
      section.querySelectorAll('.product-app-block #submit-link, .product-app-block #upload-link, .product-app-block [data-artwork-launch]').forEach(function (trigger) {
        var description = (trigger.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) { return id && id !== readiness.id && (!price || id !== price.id); });
        var ids = [readiness.id];
        if (price && !price.hidden) ids.push(price.id);
        ids.forEach(function (id) { if (id && !description.includes(id)) description.push(id); });
        var value = description.join(' ');
        if (trigger.getAttribute('aria-describedby') !== value) trigger.setAttribute('aria-describedby', value);
      });
    }
    on(section, 'input', function () { sync(); describeTools(); });
    on(section, 'change', function () { sync(); describeTools(); });
    on(section, 'click', function (event) {
      if (!event.target.closest('[data-order-jump]') || !panel || panel.hidden) return;
      if (quantity && !quantity.validity.valid) return;
      event.preventDefault();
      panel.setAttribute('tabindex', '-1');
      panel.scrollIntoView({ block: 'start' });
      panel.focus({ preventScroll: true });
    });
    var observer = new MutationObserver(describeTools);
    section.querySelectorAll('.product-app-block').forEach(function (app) { observer.observe(app, { childList: true, subtree: true }); });
    sync(); describeTools();
    cleanups.set(section, function () { controller.abort(); observer.disconnect(); });
  }
  function start(root) { nodes(root).forEach(init); }
  document.addEventListener('shopify:section:load', function (event) { queueMicrotask(function () { start(event.target); }); });
  document.addEventListener('shopify:section:unload', function (event) { nodes(event.target).forEach(function (section) { if (cleanups.has(section)) cleanups.get(section)(); }); });
  if (document.readyState === 'complete') start(document); else document.addEventListener('DOMContentLoaded', function () { start(document); });
})();
